<template>
  <div class="clock-in">
    <div class="main">
      <ClockInTheme :date="themeDate" :title="title" :content="content" :isOpen.sync="show.isOpenTheme" />
      <div class="content">
        <!-- 文字内容 -->
        <div class="text">
          <textarea
            name="text"
            id="text"
            placeholder="请填入内容"
            v-model="textContent"
            class="text-area"
          ></textarea>
          <div class="text-count">字数：{{ textContent.length }}</div>
        </div>

        <!-- 附件 -->
        <div class="attachment">
          <h4 class="tit" v-if="imgArr.length || recordArr.length || videoUrl">
            附件
          </h4>
          <!-- 图片列表 -->
          <div class="img-list" v-if="imgArr.length > 0">
            <div
              class="img-item"
              v-for="(item, index) in imgArr"
              :key="index + 'key'"
            >
              <!-- 上传成功 -->
              <img
                :src="item.id"
                alt=""
                class="img-size"
                v-if="item.state === 1"
              />
              <div
                class="img-model"
                v-if="item.state === 1"
                style="opacity: 0"
              ></div>
              <img
                src="@/assets/clock/clockin_icon_delete2.png"
                alt=""
                class="img-del"
                @click="delImgHandler(index)"
                v-if="item.state === 1"
              />
              <!-- 上传中 -->
              <div
                class="img-model"
                style="background: rgba(0, 0, 0, 0.4)"
                v-if="item.state === 0"
              >
                <div class="img-loading">
                  <div class="run-circle-bg"></div>
                  <div class="run-circle"></div>
                </div>
              </div>
              <div class="img-error" v-if="item.state === 2">
                <p @click="uploadImage(index)">
                  <img
                    src="@/assets/clockin_icon_sequel.png"
                    alt="again"
                    class="fail"
                  />重新上传
                </p>
              </div>
            </div>
            <div
              class="empty-img"
              v-if="imgArr.length === 2 || imgArr.length === 5"
            ></div>
          </div>
          <div class="atta-line" v-if="imgArr.length && recordArr.length"></div>
          <!-- 音频列表 -->
          <div class="audio-list" v-if="recordArr.length > 0">
            <div
              class="audio-item"
              v-for="(item, index) in recordArr"
              :key="item.id"
            >
              <ClockInAudio
                :audioSrc="item.id"
                :wxRecord="item.duration ? true : false"
                :wxDuration="item.duration"
                @uploadSuccess="showAudioDelBtn"
              />
              <img
                src="@/assets/clock/clockin_icon_delete.png"
                alt="delete"
                class="img-del-com"
                @click="delRecord(index)"
                v-if="item.showDel"
              />
            </div>
          </div>
          <!-- 视频列表 -->
          <UploadVideo
            :show.sync="show.videoDia"
            :src="videoUrl"
            :isBorder="imgArr.length > 0 || recordArr.length > 0"
            @upload="getVideoUrl"
            @delete="deleteVideo"
          />
        </div>
        <div class="atta-line"></div>
        <MenuBtn @menuclick="menuClick" />
      </div>
    </div>
    <div class="footer">
      <MyRadio :permission.sync="permission" />
      <div class="btn-list">
        <button class="cancel" @click="cancel">取消</button>
        <button
          class="submit"
          :class="{ 'not-click': !show.submit }"
          @click="submit"
        >
          提交
        </button>
      </div>
    </div>

    <!-- 录音弹窗 -->
    <Popup
      v-model="show.recordDia"
      position="bottom"
      :close-on-click-overlay="false"
      round
      @click-overlay="confirmEndRecord"
    >
      <div class="record">
        <img
          src="@/common/images/com_icon_close_gray@2x.png"
          alt="close"
          class="close-img-btn"
          @click="confirmEndRecord"
        />
        <div class="record-inner" v-show="!show.startRecord">
          <img
            src="@/assets/clock/clockin_icon_startrecording.png"
            alt=""
            class="start-record-img"
            @click="startRecord"
          />
          <span>开始录音</span>
        </div>
        <div class="record-inner" v-show="show.startRecord" @click="endRecord">
          <van-circle
            v-model="currentRate"
            :rate="rate"
            size="80px"
            color="#ff9645"
            :speed="100"
          >
            <img
              src="@/assets/clock/clockin_icon_endrecording.png"
              alt=""
              class="end-record-img"
            />
          </van-circle>
          <span style="margin-top: 12px"
            >{{ recordTime }}s/{{ maxRecordTime }}s</span
          >
        </div>
      </div>
    </Popup>

    <CoumunitiesDialog :show="show.protocol" :courseId="courseId" v-if="courseId" />
  </div>
</template>

<script>
import ClockInTheme from '@/components/clockInTheme/index.vue';
import ClockInAudio from '@/components/clockInAudio/index.vue';
import request from '@/plugins/axios';
import {
  Popup, Toast, Dialog, Circle
} from 'vant';
import {
  uploadWxImg,
  clockIn,
  clockInThemeApi,
  myClockInData,
} from '@/api/clockin';
import { isIos } from '@/common/js/utils';
import { initWxConfig } from '@/config/wxConfig';
import CoumunitiesDialog from '@/components/coumunitiesDialog/index.vue';
import { getProtocolInfo } from '@/api/protocol';
import UploadVideo from './components/UploadVideo.vue';
import MenuBtn from './components/MenuBtn.vue';
import MyRadio from './components/radio.vue';

export default {
  components: {
    ClockInTheme,
    ClockInAudio,
    Popup,
    MenuBtn,
    UploadVideo,
    MyRadio,
    [Circle.name]: Circle,
    CoumunitiesDialog
  },
  props: {
    id: {
      // 所属单个训练营打卡小节ID
      type: String,
      required: true,
    },
    date: {
      // 打卡日期
      type: String,
      required: true,
    },
    edit: {
      // 0 新增打卡内容，1 编辑打卡内容
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: {
        recordDia: false,
        startRecord: false,
        videoDia: false,
        submit: false,
        saveDraft: true,
        isOpenTheme: false,
        protocol: false
      },
      content: '',
      themeDate: '2021-04-01',
      title: '',
      textContent: '',
      permission: 0, // 0 所有人可见  1管理员可见
      maxRecordTime: 60, // 最大录音时长60s
      recordTime: 0, // 录音时长
      currentRate: 0, // 当前录音进度
      rate: 0, // 目标录音进度
      timer: null,
      recordArr: [], // 需要上传的音频数组，格式：[{id: '音频ID', duration: '时长', showDel: '是否显示删除按钮', url: '上传成功后的链接'}]
      lastEndTime: 0, // 上次录音结束时间
      imgArr: [], // 选择的图片数组，格式：[{id: '图片id', state: '图片状态：0 =》 上传中  1 =》 上传成功  2 =》 上传失败', url: '图片地址'}]
      loading: false,
      videoUrl: '',
      loadVideo: false,
      waitImgQueue: [],
      courseId: 0
    };
  },
  async created() {
    if (this.edit === '0' && sessionStorage.courseId) {
      this.courseId = JSON.parse(sessionStorage.courseId);

      getProtocolInfo(this.courseId).then((res) => {
        if (res.data) {
          this.show.protocol = !res.data.agree;
        }
      });
    }

    await initWxConfig();
    // eslint-disable-next-line no-undef
    wx.hideMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:share:timeline',
        'menuItem:share:qq',
        'menuItem:share:weiboApp',
        'menuItem:share:facebook',
        'menuItem:share:QZone',
        'menuItem:copyUrl'
      ]
    });
  },
  mounted() {
    this.getClockInTheme(this.id);

    if (!localStorage.clockInDraft) {
      // 没有草稿且是编辑，则向服务器请求数据
      if (this.edit === '1') {
        this.getMyClockIn(this.id);
      }

      return;
    }

    const list = JSON.parse(localStorage.clockInDraft);
    const idx = list.findIndex(item => item.detail_id === Number(this.id));

    if (idx !== -1) {
      Dialog.confirm({
        title: '使用草稿',
        message: '系统检测到存在草稿，是否使用草稿？',
        confirmButtonText: '使用',
        confirmButtonColor: '#ff9645',
      })
        .then(() => {
          // 使用草稿
          const data = list.splice(idx, 1);
          this.recoverData(data[0]);

          localStorage.clockInDraft = JSON.stringify(list);
        })
        .catch(() => {
          if (this.edit === '1') {
            this.getMyClockIn(this.id);
          }

          list.splice(idx, 1);
          localStorage.clockInDraft = JSON.stringify(list);
        });
    }

    // 没有这个打卡内容的草稿且是编辑，则向服务器请求数据
    if (idx === -1 && this.edit === '1') {
      this.getMyClockIn(this.id);
    }
  },
  watch: {
    textContent(val) {
      if (!this.show.submit && val) {
        this.show.submit = this.isClickSubmit();
      } else if (this.show.submit && !val) {
        this.show.submit = this.isClickSubmit();
      }
    },
  },
  beforeDestroy() {
    // 离开当前页面的逻辑
    if (this.show.saveDraft) {
      this.saveDraft();
    }

    if (isIos()) {
      // eslint-disable-next-line no-undef
      wx.showAllNonBaseMenuItem();
    }

    clearInterval(this.timer);
  },
  methods: {
    // 开始录音
    startRecord() {
      // 点击结束录音按钮时，多次点击可能又会触发开始录音事件（因为弹窗收起需要时间）
      if (Date.now() - this.lastEndTime < 1000) {
        return;
      }

      if (this.recordArr.length === 10) {
        Toast('最多添加十条语音');
        return;
      }

      const that = this;

      // eslint-disable-next-line no-undef
      wx.startRecord({
        success() {
          that.show.startRecord = true;

          that.timer = setInterval(() => {
            that.rate += 1.66;
            that.recordTime += 1;
          }, 1000);

          // eslint-disable-next-line no-undef
          wx.onVoiceRecordEnd({
            // 监听录音自动停止接口，超过60s自动停止
            complete(data) {
              that.recordTime = 60;

              that.recordArr.push({
                id: data.localId,
                duration: that.recordTime || 1,
                showDel: false,
              });

              that.clearZeroAudio(that);
              that.lastEndTime = Date.now();
            },
          });
        },
        fail(res) {
          console.error(res, '开始录音失败。');
        }
      });
    },
    // 结束录音
    endRecord() {
      if (!this.show.startRecord) {
        // 没有开始录音
        this.show.recordDia = false;
        return;
      }

      if (this.recordTime < 1) {
        Toast('录音时长太短～');
        return;
      }

      const that = this;

      // eslint-disable-next-line no-undef
      wx.stopRecord({
        success(res) {
          that.recordArr.push({
            id: res.localId,
            duration: that.recordTime || 1,
            showDel: false,
          });

          that.clearZeroAudio(that);
          that.lastEndTime = Date.now();
        },
        fail(res) {
          console.error(res, '停止录音失败');
        },
      });
    },
    /**
     * @description 录音相关状态重置
     * @param {object} that vue实例
     */
    clearZeroAudio(that) {
      try {
        clearInterval(that.timer);
        that.show.recordDia = false;
        that.show.startRecord = false;
        that.currentRate = 0;
        that.rate = 0;
        that.recordTime = 0;
      } catch (e) {
        console.error(e, '录音相关状态重置失败');
      }
    },
    // 删除录音
    delRecord(index) {
      // eslint-disable-next-line no-unused-vars
      let url = '';

      if (this.recordArr.length > 1) {
        const recordObj = this.recordArr.splice(index, 1);

        // eslint-disable-next-line prefer-destructuring
        url = recordObj[0].url;
      } else {
        // eslint-disable-next-line prefer-destructuring
        url = this.recordArr[0].url;

        this.recordArr = [];
      }

      if (this.recordArr.length === 0) {
        this.show.submit = this.isClickSubmit();
      }

      setTimeout(() => {
        if (localStorage.records) {
          const records = JSON.parse(localStorage.records);
          const idx = records.findIndex(item => item.url === url);

          if (idx !== -1) {
            records.splice(idx, 1);
            localStorage.records = JSON.stringify(records);
          }
        }
      }, 0);
    },
    // 上传音频成功
    showAudioDelBtn({ id, url }) {
      const index = this.recordArr.findIndex(item => item.id === id);

      if (index !== -1) {
        this.recordArr[index].showDel = true;
        this.recordArr[index].url = url;

        if (!this.show.submit) {
          this.show.submit = this.isClickSubmit();
        }
      }
    },
    // 选择图片
    async openImgDia() {
      const { length } = this.imgArr;
      if (length >= 6) {
        Toast('最多添加六张照片');
        return;
      }

      const imgs = await this.getChooseImgs(length).catch(() => []);

      if (!imgs.length) {
        return;
      }

      for (let loop = 0; loop < imgs.length; loop++) {
        const localId = imgs[loop];
        const t = Date.now();

        this.imgArr.push({
          id: localId,
          state: 0,
          t
        });

        // 因为微信不能同时上传图片所以采用一个队列来上传图片
        this.uploadImgQueue(localId, t);
      }
    },
    // 删除图片
    delImgHandler(index) {
      this.imgArr.splice(index, 1);

      if (this.imgArr.length === 0) {
        this.show.submit = this.isClickSubmit();
      }
    },
    /**
     * @description 上传图片
     * @param {object} data
     * @param {string} data.localId 图片ID
     * @param {number} data.t 时间戳
     */
    async uploadImage({ localId, t }) {
      const serverId = await this.wxUploadImg(localId).catch(() => false);

      if (!serverId) {
        // 因为用户可能删除图片，所以需要改变上传图片的状态的时候都要重新获取索引
        const index = this.imgArr.findIndex(item => item.id === localId && item.t === t);
        this.imgArr[index].state = 2;
        return;
      }

      const data = await uploadWxImg(serverId).catch(() => false);

      if (data === false) {
        // 因为用户可能删除图片，所以需要改变上传图片的状态的时候都要重新获取索引
        const index = this.imgArr.findIndex(item => item.id === localId && item.t === t);
        this.imgArr[index].state = 2;

        console.error('上传图片到服务器失败');
        return;
      }

      if (!data.data.upload) {
        // 因为用户可能删除图片，所以需要改变上传图片的状态的时候都要重新获取索引
        const index = this.imgArr.findIndex(item => item.id === localId && item.t === t);
        this.imgArr[index].state = 2;
        return;
      }

      const { url } = data.data;
      // 在iOS中使用localId不能显示图片
      if (isIos()) {
        // 因为用户可能删除图片，所以需要改变上传图片的状态的时候都要重新获取索引
        const idx = this.imgArr.findIndex(item => item.id === localId && item.t === t);
        this.imgArr[idx].id = url;
      }

      // 因为用户可能删除图片，所以需要改变上传图片的状态的时候都要重新获取索引
      const index = this.imgArr.findIndex(item => (item.id === localId || item.id === url) && item.t === t);
      this.imgArr[index].url = url;
      this.imgArr[index].state = 1;

      if (!this.show.submit) {
        this.show.submit = this.isClickSubmit();
      }
    },
    /**
     * @description 返回提交打卡/保存草稿所需的参数对象
     */
    backData() {
      const id = Number(this.id);

      const data = {
        visible_range: this.permission,
        detail_id: id,
        content: this.textContent,
      };

      if (this.videoUrl) {
        data.video_url = this.videoUrl;
      }

      if (this.recordArr.length > 0) {
        let recordArr = this.recordArr.filter(item => item.url !== undefined);

        if (recordArr.length > 0) {
          recordArr = recordArr.map(item => item.url);

          data.multi_voices = recordArr;
        }
      }

      if (this.imgArr.length > 0) {
        let imgArr = this.imgArr.filter(item => item.url !== undefined);

        if (imgArr.length > 0) {
          imgArr = imgArr.map(item => item.url);

          data.multi_images = imgArr;
        }
      }

      return data;
    },
    submit() {
      if (!this.isClickSubmit() || this.loading) {
        return;
      }

      if (this.imgArr.length > 0) {
        const uploadImg = this.imgArr.some(item => item.state === 0);

        if (uploadImg) {
          Toast('请耐心等待图片上传完成');
          return;
        }
      }

      if (this.recordArr.length) {
        const uploadRecord = this.recordArr.some(item => item.state === 0);

        if (uploadRecord) {
          Toast('请耐心等待录音上传完成');
          return;
        }
      }

      if (this.loadVideo) {
        Toast('请耐心等待视频上传完成');
        return;
      }

      this.loading = true;
      const data = this.backData();

      clockIn(data)
        .then((res) => {
          if (res.success) {
            // 打卡成功，跳转主题页
            this.loading = false;
            this.show.saveDraft = false;

            this.$router.replace({
              name: 'clock-in-theme',
              params: {
                date: this.date,
                edit: Number(this.edit)
              },
              query: {
                id: this.id,
                t: Date.now()
              }
            });
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    cancel() {
      if (this.isClickSubmit()) {
        // 保存草稿后再跳转
        Dialog.confirm({
          title: '保存草稿',
          message: '是否保存草稿？',
          confirmButtonText: '保存',
          confirmButtonColor: '#ff9645',
        })
          .then(() => {
            this.saveDraft();
          })
          .catch(() => {
            this.show.saveDraft = false;
            this.$router.replace(`/clock-in-theme?id=${this.id}`);
          });
      } else {
        this.loading = true;
        this.$router.replace(`/clock-in-theme?id=${this.id}`);
      }
    },
    saveDraft() {
      if (!this.isClickSubmit() || this.loading) {
        return;
      }

      this.loading = true;
      const data = this.backData();

      if (localStorage.clockInDraft) {
        const list = JSON.parse(localStorage.clockInDraft);

        if (list.length > 100) {
          list.splice(0, 50);
        }

        const idx = list.findIndex(item => item.detail_id === data.detail_id);

        if (idx === -1) {
          list.push(data);
        } else {
          list[idx] = data;
        }

        localStorage.clockInDraft = JSON.stringify(list);
      } else {
        localStorage.clockInDraft = JSON.stringify([data]);
      }

      this.loading = false;
      this.$router.push('/clock-in-theme');
    },
    /**
     * @description 获取打卡主题数据
     */
    getClockInTheme(id) {
      clockInThemeApi({ detail_id: id }).then((res) => {
        const { data } = res;

        this.themeDate = data.content_data.unlock_time.substr(0, 10);

        // eslint-disable-next-line camelcase
        const { punch_data } = data;
        this.title = punch_data.title;

        // 获取富文本内容
        const url = punch_data.content;

        request({
          method: 'get',
          url,
          withCredentials: false,
        }).then((content) => {
          this.content = content;
        });
      });
    },
    /**
     * @description 获取我的打卡数据
     */
    getMyClockIn(id) {
      myClockInData(id).then((res) => {
        const data = res.data.user_punch_data;
        this.recoverData(data);
      });
    },
    /**
     * @description 根据草稿还原数据
     */
    recoverData(data) {
      this.textContent = data.content;
      this.permission = data.visible_range;

      if (data.multi_images && data.multi_images.length) {
        this.imgArr = data.multi_images.map(item => ({
          id: item,
          state: 1,
          url: item,
        }));
      }

      if (data.video_url) {
        this.videoUrl = data.video_url;
      }

      if (data.multi_voices && data.multi_voices.length) {
        this.recordArr = data.multi_voices.map(item => ({
          id: item,
          duration: 0,
          showDel: true,
          url: item,
        }));
      }

      this.show.submit = true;
    },
    /**
     * @description 将图片上传至微信
     * @param {string} localId 图片ID
     * @returns {promise} 成功resolve(serverId)，失败reject()
     */
    wxUploadImg(localId) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        wx.uploadImage({
          localId, // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 0, // 默认为1，显示进度提示
          success(res) {
            const { serverId } = res; // 返回图片的服务器端ID
            resolve(serverId);
          },
          fail(err) {
            console.error('获取图片的服务端ID失败', err);
            reject();
          }
        });
      });
    },
    /**
     * @description 提交按钮是否可点击，true可以
     */
    isClickSubmit() {
      if (this.textContent) {
        return true;
      }

      const record = this.recordArr;
      if (record.length > 0 && record.some(item => item.url !== undefined)) {
        return true;
      }

      const imglist = this.imgArr;
      if (
        imglist.length > 0
        && imglist.some(item => item.url !== undefined)
      ) {
        return true;
      }

      if (this.videoUrl) {
        return true;
      }

      return false;
    },
    /**
     * @description 确认是否要结束录音
     */
    confirmEndRecord() {
      if (!this.show.startRecord) {
        this.show.recordDia = false;
        return;
      }

      Dialog.confirm({
        title: '温馨提示',
        message: '正在录音是否退出',
        confirmButtonText: '确定',
        confirmButtonColor: '#FF9645',
        cancelButtonColor: '#999999',
      })
        .then(() => {
          // eslint-disable-next-line no-undef
          wx.stopRecord();
          this.clearZeroAudio(this);
        })
        .catch(() => {});
    },
    /**
     * @description 底部工具栏点击事件
     */
    menuClick(idx) {
      if (idx === 1) {
        // 语音
        this.show.recordDia = true;
      } else if (idx === 2) {
        // 图片
        this.openImgDia();
      } else if (idx === 3) {
        //  视频
        if (this.videoUrl || this.loadVideo) {
          Toast('最多添加一个视频');
          return;
        }

        this.show.videoDia = true;
      }
    },
    getVideoUrl(data) {
      this.videoUrl = data.url;
      this.loadVideo = data.loading;
      this.show.submit = this.isClickSubmit();
    },
    deleteVideo() {
      this.videoUrl = '';
      this.show.submit = this.isClickSubmit();
    },
    /**
     * @description 获取用户选择的图片列表
     * @param {number} [length = 0] 已选择的图片长度，默认0
     * @returns {promise} 调用微信接口成功resolve用户选择的图片列表，失败reject
     */
    getChooseImgs(length = 0) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        wx.chooseImage({
          count: 6 - length,
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success(res) {
            const { localIds } = res; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片

            resolve(localIds);
          },
          fail(err) {
            console.error('调用微信sdk上传图片错误', err);
            reject();
          }
        });
      });
    },
    /**
     * @description 上传图片队列
     * @param {string} localId 微信图片ID
     * @param {number} t 时间戳
     */
    uploadImgQueue(localId, t) {
      if (this.waitImgQueue.length === 0) {
        this.waitImgQueue.push({ localId, t });

        const queue = () => {
          const first = this.waitImgQueue[0];

          this.uploadImage(first).then(() => {
            this.waitImgQueue.splice(0, 1);

            if (this.waitImgQueue.length !== 0) {
              queue();
            }
          });
        };

        queue();
      } else {
        this.waitImgQueue.push({ localId, t });
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
imgSize =
  width: 29.03vw;
  height: 29.03vw;
videoSize =
  width: 160px;
  height: 90px;
flexajc =
  display: flex;
  align-items: center;
  justify-content: center;
flexaicjb =
  display: flex;
  align-items: center;
  justify-content: space-between;
poabt0l0 =
  position: absolute;
  top: 0;
  left: 0;

.clock-in {
  position: relative;
}

.main {
  min-height: calc(100vh - 90px);
}

.content {
  margin-top: 8px;
  margin-bottom: 120px;
  padding: 12px 16px 0 16px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
}

.text {
  position: relative;
  margin-bottom: 20px;
  padding: 12px 12px 20px 12px;
  box-sizing: border-box;
  width: 100%;
  height: 150px;
  background: #F6F7FA;
  border-radius: 8px;

  .text-area {
    width: 100%;
    height: 114px;
    resize: none;
    border: none;
    outline: none;
    background: #F6F7FA;
    caret-color: #5580AE;
    font-size: 15px;
    line-height: 22px;
    color: #191919;

    &::-webkit-input-placeholder {
      color: #dadada;
    }
  }

  .text-count {
    position: absolute;
    bottom: 12px;
    right: 12px;
    font-size: 12px;
    color: #dadada;
  }
}

.attachment {
  width: 100%;

  .tit {
    font-size: 16px;
    color: #000;
  }

  .img-list {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    justify-content: space-between;
    padding: 12px 0;
    width: 100%;

    .empty-img {
      {imgSize};
    }

    .img-item {
      position: relative;
      margin: 0 0 8px 0;
      {imgSize};
      background: url('../../common/images/default.jpg') no-repeat;
      background-size: cover;

      .img-del {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        width: 25px;
        height: 24px;
      }

      .img-size {
        {imgSize};
      }

      .img-model {
        {poabt0l0};
        z-index: 9;
        {flexajc};
        {imgSize};
      }

      .img-error {
        {flexajc};
        {imgSize};
        font-size: 12px;
        color: #fff;

        .fail {
          margin-right: 8px;
          width: 18px;
          height: 18px;
        }
      }
    }
  }

  .audio-list {
    padding: 0 0 20px 0;
    width: 100%;
  }

  .audio-item {
    {flexaicjb};
    margin-top: 12px;
    width: 100%;
  }
}

.img-del-com {
  width: 25px;
  height: 24px;
  border: none;
}

.footer {
  position: fixed;
  bottom: 0;
  z-index: 20;
  padding: 12px 16px;
  width: 100%;
  max-width: 750px;
  min-width: 320px;
  background: #fff;
  border-top: 0.5px solid #e7e7e7;
}

.btn-list {
  {flexaicjb};
  margin-top: 12px;

  .cancel {
    width: 27%;
    height: 40px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #FF9645;
    font-size: 16px;
    color: #FF9645;
    outline: none;
  }

  .submit {
    width: 61%;
    height: 40px;
    background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
    border-radius: 6px;
    font-size: 16px;
    color: #fff;
    border: none;
    outline: none;
  }

  .not-click {
    background: #dadada;
  }
}

.record {
  position: relative;
  {flexajc};
  flex-direction: column;
  width: 100%;
  height: 250px;
  font-size: 14px;
  color: #999;

  .start-record-img {
    margin-bottom: 12px;
    width: 80px;
    height: 80px;
  }

  .record-inner {
    {flexajc};
    flex-direction: column;
  }

  .end-record-img {
    width: 80px;
    height: 80px;
    border: none;
  }

  .close-img-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    display: block;
    width: 22px;
    height: 22px;
    border: none;
  }
}

.img-loading {
  position: relative;
}

.run-circle-bg {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
}

.run-circle {
  {poabt0l0};
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: loading 2s linear 0s infinite normal;
}

@keyframes loading {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.atta-line {
  width: 100%;
  height: 0.5px;
  background: #e7e7e7;
}
</style>
